/* eslint-disable max-len */
import React, { PureComponent } from 'react';
import { Col, Row, Container } from 'reactstrap';
import scrollToComponent from 'react-scroll-to-component';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Header from './components/Header';
import Technologies from './components/Technologies';
import Demos from './components/Demos';
import Features from './components/Features';
import AccountOutlineIcon from 'mdi-react/AccountOutlineIcon';
import CardIcon from 'mdi-react/CardIcon';
import PhoneOutlineIcon from 'mdi-react/PhoneOutlineIcon';
import { ReactComponent as CloseMenu } from "./x.svg";
import { ReactComponent as MenuIcon } from "./menu.svg";
import { ReactComponent as Logo } from "./logo.svg";
import Purchase from './components/Purchase';
import Footer from './components/Footer';
import Testimonials from './components/Testimonials';
import FeatureRequest from './components/FeatureRequest';
import Feedback from './components/Feedback';
import Code from './components/Code';
import Applications from './components/Applications';
import { changeThemeToDark, changeThemeToLight } from '../../redux/actions/themeActions';
import { ThemeProps } from '../../shared/prop-types/ReducerProps';
import Modal from 'react-modal';
import { NavLink } from 'react-router-dom';
import './style2.css';
import { Form } from 'react-bootstrap';
import { Button } from 'reactstrap';
import { MDBCloseIcon } from "mdbreact"
import { baseURL } from '../../_helpers';
import axios from 'axios';
import KeyVariantIcon from 'mdi-react/KeyVariantIcon';
import EyeIcon from 'mdi-react/EyeIcon';
import AlternateEmailIcon from 'mdi-react/AlternateEmailIcon';
import Alert from '../../shared/components/Alert';
import { Card } from '@material-ui/core';
import img from '../../_assets/img/save.jpeg'

const logo = `${process.env.PUBLIC_URL}/img/landing/logo.svg`;

class Landing extends PureComponent {
  constructor(props) {
    super(props);
    this.onSubmitRequestPassword = this.onSubmitRequestPassword.bind(this);
    this.onSubmitRequestAgent = this.onSubmitRequestAgent.bind(this);
    this.onAddAgent = this.onAddAgent.bind(this);
    this.otpgo = this.otpgo.bind(this);
    this.changetologin = this.changetologin.bind(this);


    this.onSubmit = this.onSubmit.bind(this);
    this.state = {
      isOpen1: false,
      email_address: "",
      password: "",
      msisdn: "",
      showAgentReset: false,
      showPassword: false,
      setShowPassword: false,
      channel_type: "portal",
      error: "",
      errorMsg: "",
      showAddAgent: false,
      showOTP: false,
      role: "",
      otpConfirmation: false,
      loginshow: true,
      id: "",
      user: [],
      statusMessage: "",
      isShowSuccess: false,
      submitted: false,
      alert_error_color: "",
      isLoggedIn: false,
      isChecked: false,
      errorShow: false,
      successShow: false,
      statis: []
    };
  }

  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    theme: ThemeProps.isRequired,
  };


  changeToDark = () => {
    const { dispatch } = this.props;
    dispatch(changeThemeToDark());
  };
  handleClick = () => {
    if (this.state.click) {
      this.setState({
        click: false
      })
    } else {
      this.setState({
        click: true
      })
    }
  }
  changeToLight = () => {
    const { dispatch } = this.props;
    dispatch(changeThemeToLight());
  };

  toggleModal1 = e => {
    this.setState({
      isOpen1: true,
    });
  };
  closeModal1 = e => {
    this.setState({
      isOpen1: false,
      loginshow: true
    });
  };
  handleChangeEmail = event => {
    this.setState({ agent_no: event.target.value });
  };


  handleChangeEmailAddress = event => {
    this.setState({ email_address: event.target.value });
  };

  handleChangeOTP = event => {

    this.setState({ optnumber: event.target.value });

  };


  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  }

  handleChangePassword = event => {

    this.setState({ password: event.target.value });
  };


  handleChangePhone = event => {
    this.setState({ msisdn: event.target.value });
  };
  showPasswordToggle = () => {
    // eslint-disable-next-line
    if (this.state.showPassword == true) {
      this.setState({
        showPassword: false,
      })
    } else {
      this.setState({
        showPassword: true,
      })
    }
  };
  changecontent = () => {
    this.setState({
      loginshow: false,
      isOpen1: true,
      showOTP: false,
      showAgentReset: false,
      otpConfirmation: false,
      showAddAgent: true
    })
  }
  changetologin = () => {
    this.setState({
      // loginshow: true,
      showAgentReset: false,
      showAddAgent: false,
      otpConfirmation: false,
      showOTP: false
    })
  }
  check2 = e => {
    // eslint-disable-next-line
    if (this.state.selectedValue2 == '') {
      alert("You haven't select any tax");
    } else {
      this.setState({
        isOpen1: false,
      });
    }
  };
  closeModal1 = e => {
    this.setState({
      isOpen1: false,
    });
  };

  resetpasswordchange = e => {
    this.setState({
      showOTP: true,
      loginshow: false,
      isOpen1: true,
      showAgentReset: false,
      otpConfirmation: false,
      showAddAgent: false
    });
  };
  otpgo = e => {
    this.setState({
      showOTP: false,
      loginshow: false,
      showAgentReset: false,
      otpConfirmation: true,
      showAddAgent: false
    });
  };


  resetagentchange = e => {
    this.setState({
      showOTP: false,
      isOpen1: true,
      loginshow: false,
      showAgentReset: true,
      otpConfirmation: false,
      showAddAgent: false
    });
  };


  closeMobileMenu = () => {
    this.setState({
      click: false
    });
  }


  onSubmit = e => {
    e.preventDefault();
    this.setState({ isLoading: true });
    if (this.state.agent_no === "" || this.state.password === "") {
      this.setState({
        isLoading: false,
        error: "Agent No. and Password is required",
        errorShow: true,
        alert_error_color: "alert alert-danger"
      });
    } else {
      let formData = {
        "agent_id": this.state.agent_no,
        "password": this.state.password
      }
      console.log("DATA", formData)
      this.setState({ isLoading: true });
      axios.post(baseURL + 'login_agent', formData)
        .then((response) => {
          console.log('response', response)

          console.log("token", JSON.stringify(response.data));

          if (response.data.code === "0000" && response.data.status === "active") {
            this.setState({
              statusMessage: response.data.message,
              isShowError: true, isLoading: false, showError: false,
            }, function () {
              localStorage.setItem("AGENTID", this.state.agent_no)
              if (response.data.role == "agent") {
                localStorage.setItem("ROLE", 2)
              } else if (response.data.role == "admin") {
                localStorage.setItem("ROLE", 1)
              }

              // eslint-disable-next-line
              window.setTimeout(function () {
                window.location.href = "/account/profile";
                this.setState({
                  isLoading: false,
                  showOTP: false,
                  loginshow: false,
                  showAgentReset: false,
                  otpConfirmation: false,
                  showAddAgent: false
                });
              }, 2000);
            });
            localStorage.setItem('token', response.data.session_id)

          }
          else {
            this.setState({ statusMessage: response.data.message, showError: true, isShowError: false, isLoading: false });
            window.setTimeout(() => {
              this.setState({
                isLoading: false,
                isShowError: false,
                showError: false

              });
            }, 2000);
          }

        }).catch(error => {
          console.log('bayoo', error.response)
          this.setState({
            alert_error_color: "alert alert-danger",
            errorShow: true,
            error: error.response === undefined ? "Check your internet" : error.response.data.message,
            isLoading: false
          }
            , function () {
              // console.log('data', error.response.status_message)
            });
          window.setTimeout(() => {
            this.setState({
              isLoading: false,
              isShowError: false,
              showError: false,
              errorShow: false,
              error: ""
            });
          }, 2000);
        });
      this.setState({ password: "", email_address: "" });
    }
  };



  onSubmitRequestPassword = e => {
    e.preventDefault();
    this.setState({ isLoading: true });
    if (this.state.agent_no === "") {
      this.setState({
        isLoading: false,
        error: "Agent id is required",
        errorShow: true,
        alert_error_color: "alert alert-danger"
      });
    } else {
      let formData = {
        "agent_id": this.state.agent_no,
      }
      console.log("DATA", formData)
      this.setState({ isLoading: true });
      axios.post(baseURL + 'reset_agent_password', formData)
        .then((response) => {
          console.log("response", response)
          if (response.data.code === "0000" && response.data.status === "active") {
            this.setState({
              statusMessage: response.data.message,
              isShowError: true, isLoading: false, showError: false,
            }, function () {
              // eslint-disable-next-line
              window.setTimeout(function () {
                // window.location.href = "/adminview";
                this.setState({
                  isLoading: false,
                  loginshow: false,
                  isShowError: false,
                  isOpen1: false,
                  showAgentReset: false,
                  showAddAgent: false,
                  otpConfirmation: false,
                  showOTP: false
                });
              }, 2000);
            });
            localStorage.setItem('token', response.data.session_id)

          }
          else {
            this.setState({ statusMessage: response.data.message, showError: true, isShowError: false, isLoading: false });
            window.setTimeout(() => {
              this.setState({
                isLoading: false,
                isShowError: false,
                showError: false

              });
            }, 2000);
          }

        }).catch(error => {
          console.log('bayoo', error.response)
          this.setState({
            alert_error_color: "alert alert-danger",
            errorShow: true,
            error: error.response === undefined ? "Check your internet" : error.response.data.message,
            isLoading: false
          }
            , function () {
              // console.log('data', error.response.status_message)
            });

          window.setTimeout(() => {
            this.setState({
              isLoading: false,
              isShowError: false,
              showError: false,
              errorShow: false,
              error: ""
            });
          }, 2000);
        });
      this.setState({ password: "", email_address: "" });
    }
  };



  onSubmitRequestAgent = e => {
    e.preventDefault();
    this.setState({ isLoading: true });
    if (this.state.agent_no === "") {
      this.setState({
        isLoading: false,
        error: "Agent id is required",
        errorShow: true,
        alert_error_color: "alert alert-danger"
      });
    } else {
      let formData = {
        "msisdn": this.state.msisdn,
      }
      console.log("DATA", formData)
      this.setState({ isLoading: true });
      axios.post(baseURL + 'get_agent_id', formData)
        .then((response) => {

          if (response.data.code === "0000" && response.data.status === "active") {
            this.setState({
              statusMessage: response.data.message,
              isShowError: true, isLoading: false, showError: false,
            }, function () {
              // eslint-disable-next-line
              window.setTimeout(function () {
                // window.location.href = "/adminview";
                this.setState({
                  isLoading: false,
                  loginshow: false,
                  isOpen1: false,
                  isShowError: false,
                  showAgentReset: false,
                  otpConfirmation: false,
                  showAddAgent: false,
                  showOTP: false
                });
              }, 2000);
            });
            localStorage.setItem('token', response.data.session_id)

          }
          else {
            this.setState({ statusMessage: response.data.message, showError: true, isShowError: false, isLoading: false });
            window.setTimeout(() => {
              this.setState({
                isLoading: false,
                isShowError: false,
                showError: false

              });
            }, 2000);
          }

        }).catch(error => {
          console.log('bayoo', error.response)
          this.setState({
            alert_error_color: "alert alert-danger",
            errorShow: true,
            error: error.response === undefined ? "Check your internet" : error.response.data.message,
            isLoading: false
          }
            , function () {
              // console.log('data', error.response.status_message)
            });

          window.setTimeout(() => {
            this.setState({
              isLoading: false,
              isShowError: false,
              showError: false,
              errorShow: false,
              error: ""
            });
          }, 2000);
        });
      this.setState({ password: "", email_address: "" });
    }
  };

  onAddAgent = e => {
    e.preventDefault();
    this.setState({ isLoading: true });

    let formData = {
      "name": this.state.name,
      "email": this.state.email_address,
      "msisdn": this.state.msisdn
    }
    this.setState({ isLoading: true });
    axios.post(baseURL + 'add_agent', formData)
      .then((response) => {
        // alert(JSON.stringify(response))
        localStorage.setItem('responsereceived', response.data.request_id)
        if (response.data.code === "0000") {
          this.setState({
            statusMessage: response.data.message,
            isShowError: true, isLoading: false, showError: false
          }, function () {
            // eslint-disable-next-line
            window.setTimeout(() => {
              this.otpgo();
              this.setState({
                isLoading: false,
                isShowError: false
              });
            }, 2000);
          });
        }
        else {
          this.setState({ statusMessage: response.data.message, showError: true, isShowError: false, isLoading: false });
          window.setTimeout(() => {
            this.setState({
              isLoading: false,
              isShowError: false,
              showError: false

            });
          }, 2000);
        }

      }).catch(error => {
        console.log('bayoo', error.response)
        this.setState({
          alert_error_color: "alert alert-danger",
          errorShow: true,
          error: error.response === undefined ? "Check your internet" : error.response.data.message,
          isLoading: false
        }
          , function () {
            // console.log('data', error.response.status_message)
          });

        window.setTimeout(() => {
          this.setState({
            isLoading: false,
            isShowError: false,
            showError: false,
            errorShow: false,
            error: ""
          });
        }, 2000);
      });
    this.setState({ password: "", email_address: "" });
  };


  OTPConfirmation = e => {
    e.preventDefault();
    this.setState({ isLoading: true });
    // x
    let formData = {
      "otp": this.state.optnumber,
      "request_id": localStorage.getItem("responsereceived"),
    }
    console.log('response', formData)
    // alert(JSON.stringify(formData))
    this.setState({ isLoading: true });
    axios.post(baseURL + 'confirm_agent', formData)
      .then((response) => {
        console.log("token", JSON.stringify(response.data));
        if (response.data.code === "0000") {
          this.setState({
            statusMessage: response.data.message,
            isShowError: true, isLoading: false, showError: false,

          }, function () {
            // eslint-disable-next-line
            window.setTimeout(() => {
              this.changetologin();
              this.setState({
                isLoading: false,
                isOpen1: false,
                isShowError: false
              });
            }, 2000);
          });
          localStorage.setItem('token', response.data.session_id)

        }
        else {
          this.setState({ statusMessage: response.data.message, showError: true, isShowError: false, isLoading: false });
          window.setTimeout(() => {
            this.setState({
              isLoading: false,
              isShowError: false,
              showError: false

            });
          }, 2000);
        }

      }).catch(error => {
        console.log('bayoo', error.response)
        this.setState({
          alert_error_color: "alert alert-danger",
          errorShow: true,
          error: error.response === undefined ? "Check your internet" : error.response.data.message,
          isLoading: false
        }
          , function () {
            // console.log('data', error.response.status_message)
          });

        window.setTimeout(() => {
          this.setState({
            isLoading: false,
            isShowError: false,
            showError: false,
            errorShow: false,
            error: ""
          });
        }, 2000);
      });
    this.setState({ password: "", email_address: "" });
  };



  aboutAgent = () => {
    this.closeMobileMenu();
    scrollToComponent(this.About,
      { offset: -50, align: 'top', duration: 1000 });
  }



  render() {
    const { theme } = this.props;
    const { submitted, showPassword, errorShow, otpConfirmation, showAgentReset, showAddAgent, showOTP, loginshow } = this.state;
    return (

      <div className="landing">
        <div className="elite-login">
          <div className="elite-login-sec">
            <div className="row">
              <div className="col-md-6 elite-login-left">
                <div className="carousel-wrap">
                  <div className="owl-carousel">
                    <div className="item">
                      <div className="item-sec">
                        <div className="login_slider_image"><img src={img} /></div>
                        <p className="item-text" style={{ color: "white" }}>Premium Local Advertising Solutions</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-6 elite-login-right">
                <h1 className="elite-login-head">Agency Login</h1>

                <form className="new_user" id="new_user" onSubmit={this.onSubmit} >
                  <div className="elite-login-form">
                    {this.state.isShowError ? (
                      <Alert color="success" className="alert--colored" >
                        <span>
                          {this.state.statusMessage}
                        </span>
                      </Alert>
                    ) : null}
                    {errorShow && (
                      <div>
                        <div
                          color="red"
                          style={{ fontSize: "13px", color: "red" }}>
                          {this.state.error}
                        </div>
                      </div>
                    )}
                    <div className="elite-form-field">
                      <label htmlFor="user_email">Agent ID</label>
                      <input className="form-control"
                        placeholder="Enter your Agent ID"
                        id="elite-email"
                        required="required"
                        type="text"
                        value={this.state.agent_no}
                        onChange={this.handleChangeEmail}
                        style={{ borderColor: "grey" }}
                        name="email_address" />
                    </div>
                    <div className="elite-form-field">
                      <label htmlFor="user_email">Password</label>
                      <input placeholder="Enter your password"
                        id="elite-email"
                        className="form-control"
                        required="required"
                        style={{ borderColor: "grey" }}
                        value={this.state.password}
                        onChange={this.handleChangePassword}
                        type="password"
                      />
                      <input type="hidden" name="user_timezone" id="user_timezone" />
                      <br /><br />
                    </div>



                    <p className="elite-forgot-pwd" onClick={this.resetpasswordchange}><a href="#"
                      data-toggle="modal" onClick={this.resetpasswordchange} data-target="#specialist-forgotModal">
                      Forgot Password?
                        </a></p>
                    <p className="elite-agent-pwd" ><a href="#" onClick={this.resetagentchange}
                      data-toggle="modal" data-target="#specialist-forgotModal">
                      Forgot Agent ID?
                        </a></p>

                    <button type="submit" className="elite-form-btn"> {
                      this.state.isLoading ? "Please wait..." : "Sign In"}
                    </button>
                    <p className="elite-form-signup">Don't have an account? <a href="#" data-toggle="modal" data-target="#specialist-forgotModal" onClick={this.changecontent}>Register here</a></p>
                    <p className="elite-form-query">Any questions? Contact Us  <a href="tel:080-6523-7045">080-6523-7045</a></p>
                  </div>
                </form>
              </div>
              {/* <p onClick={this.resetpasswordchange}>Forgot Password?</p><br></br> */}



              {/* Forgot Password Modal E*/}

              <div id="specialist-forgotModal">
                <Modal
                  isOpen={this.state.isOpen1}
                  onRequestClose={e => {
                    this.closeModal1(e);
                  }}
                  
                  contentLabel="My dialog"
                  className="mymodal"
                  onAfterOpen={() => {
                    document.body.style.overflow = 'hidden';
                  }}
                  onAfterClose={() => {
                    document.body.removeAttribute('style');
                  }}
                  overlayClassName="myoverlay"
                  closeTimeoutMS={500}>
                  <MDBCloseIcon onClick={this.closeModal1} />
                  <h4><b>AGENCY</b></h4>
                  <br></br>
                  {loginshow ? (
                    <>
                      <Form className="form login-form" onSubmit={this.onSubmit}>
                        <h5><b>Login Page</b></h5>

                        <div className="form__form-group">
                          <br></br>
                          {this.state.isShowError ? (
                            <Alert color="success" className="alert--colored" >
                              <span>
                                {this.state.statusMessage}
                              </span>
                            </Alert>
                          ) : null}
                          {errorShow && (
                            <div>
                              <div
                                color="red"
                                style={{ fontSize: "13px", color: "red" }}>
                                {this.state.error}
                              </div>
                            </div>
                          )}
                          <span className="form__form-group-label">Agent No</span>
                          <div className="form__form-group-field">
                            <div className="form__form-group-icon">
                              <CardIcon />
                            </div>
                            <Form.Control
                              autoFocus
                              type="text"
                              name="agent_no"
                              style={{ color: "black", borderColor: "hsl(0,0%,80%)" }}
                              placeholder="Agent No."
                              className="input-without-border-radius"
                              value={this.state.agent_no}
                              onChange={this.handleChangeEmail}
                            />
                          </div>
                        </div>
                        <div className="form__form-group">
                          <span className="form__form-group-label">Password</span>
                          <div className="form__form-group-field">
                            <div className="form__form-group-icon">
                              <KeyVariantIcon />
                            </div>
                            <Form.Control
                              value={this.state.password}
                              placeholder="Password"
                              name="password"
                              style={{ color: "black", borderColor: "hsl(0,0%,80%)" }}
                              type={showPassword ? 'text' : 'password'}
                              className="input-without-border-radius"
                              onChange={this.handleChangePassword}
                            />
                            <button
                              type="button"
                              className={`btn-orange form__form-group-button${showPassword ? 'active' : ''}`}
                              onClick={this.showPasswordToggle}
                            ><EyeIcon />
                            </button>
                          </div>
                          <div className="float-right" >
                            <a href="#" style={{ marginTop: '10px' }} onClick={this.resetpasswordchange
                            } className="float-right">Forgot Password?</a><br></br>
                            <a href="#" style={{ marginTop: '10px' }} onClick={this.resetagentchange
                            } className="float-right">Forgot Agent id?</a>
                          </div>
                        </div>
                        <div className="form__form-group">
                        </div>
                        <div className="account__btns">

                          <Button className="account__btn" type='submit' color="primary"> {
                            this.state.isLoading ? "Please wait..." : "Sign In"
                          }</Button>
                        </div>
                        <div className="account__have-account">
                          <p>Don't have an account? <a href="#" onClick={this.changecontent}>Register here</a></p>
                        </div>
                      </Form>
                    </>
                  ) : null}
                  {showAddAgent ? (
                    <Form className="form login-form" onSubmit={this.onAddAgent}>
                      <h5><b>Registration</b></h5>
                      <div className="form__form-group">
                        <br></br>
                        {this.state.isShowError ? (
                          <Alert color="success" className="alert--colored" >
                            <span>
                              {this.state.statusMessage}
                            </span>
                          </Alert>
                        ) : null}
                        {errorShow && (
                          <div>
                            <div
                              color="red"
                              style={{ fontSize: "13px", color: "red" }}>
                              {this.state.error}
                            </div>
                          </div>
                        )}
                        <span className="form__form-group-label">Fullname</span>
                        <div className="form__form-group-field">
                          <div className="form__form-group-icon">
                            <AccountOutlineIcon />
                          </div>
                          <Form.Control
                            autoFocus
                            type="text"
                            required
                            name="name"
                            placeholder="Fullname"
                            className="input-without-border-radius"
                            value={this.state.admin_names}
                            onChange={this.handleChange}
                          />
                        </div>
                      </div>
                      <div className="form__form-group">
                        <span className="form__form-group-label">Email Address</span>
                        <div className="form__form-group-field">
                          <div className="form__form-group-icon">
                            <AlternateEmailIcon />
                          </div>
                          <Form.Control
                            type="email"
                            required
                            name="email_address"
                            placeholder="Email Address"
                            className="input-without-border-radius"
                            value={this.state.email_address}
                            onChange={this.handleChangeEmailAddress}
                          />
                        </div>
                      </div>
                      <div className="form__form-group">
                        <span className="form__form-group-label">Phone No.</span>
                        <div className="form__form-group-field">
                          <div className="form__form-group-icon">
                            <PhoneOutlineIcon />
                          </div>
                          <Form.Control
                            value={this.state.msisdn}
                            placeholder="Phone"
                            name="msisdn"
                            required
                            type='number'
                            className="input-without-border-radius"
                            onChange={this.handleChangePhone}
                          />
                        </div>
                        <br />
                      </div>
                      <div className="account__btns">
                        <Button className="account__btn" type='submit' color="primary"> {
                          this.state.isLoading ? "Please wait..." : "Rigister"
                        }</Button>
                      </div>
                      <div className="account__have-account">
                        <p>Received an OTP? <a href="#" onClick={this.otpgo}>Confirm OTP</a></p>
                      </div>
                    </Form>
                  ) : null}
                  {showOTP ? (
                    <>
                      <Form className="form login-form" onSubmit={this.onSubmitRequestPassword}>
                        <h5><b>Reset Password</b></h5>
                        <div className="form__form-group">
                          <br></br>
                          {this.state.isShowError ? (
                            <Alert color="success" className="alert--colored" >
                              <span>
                                {this.state.statusMessage}
                              </span>
                            </Alert>
                          ) : null}
                          {errorShow && (
                            <div>
                              <div
                                color="red"
                                style={{ fontSize: "13px", color: "red" }}>
                                {this.state.error}
                              </div>
                            </div>
                          )}
                          <span className="form__form-group-label">Agent No</span>
                          <div className="form__form-group-field">
                            <div className="form__form-group-icon">
                              <CardIcon />
                            </div>
                            <Form.Control
                              autoFocus
                              type="text"
                              required
                              name="agent_no"
                              placeholder="Agent No."
                              className="input-without-border-radius"
                              value={this.state.agent_no}
                              onChange={this.handleChangeEmail}
                            />
                          </div>
                          <br />
                        </div>
                        <div className="account__btns">
                          <Button className="account__btn" type='submit' color="primary"> {
                            this.state.isLoading ? "Please wait..." : "Submit"
                          }</Button>
                        </div>
                        {/* <div className="account__have-account">
                    <p>Back to Login? <a href="#" onClick={this.changetologin}>Login</a></p>
                  </div> */}
                      </Form>
                    </>
                  ) : null}
                  {showAgentReset ? (
                    <>
                      <Form className="form login-form" onSubmit={this.onSubmitRequestAgent}>
                        <h5><b>Reset Agent ID</b></h5>
                        <div className="form__form-group">
                          <br></br>
                          {this.state.isShowError ? (
                            <Alert color="success" className="alert--colored" >
                              <span>
                                {this.state.statusMessage}
                              </span>
                            </Alert>
                          ) : null}
                          {errorShow && (
                            <div>
                              <div
                                color="red"
                                style={{ fontSize: "13px", color: "red" }}>
                                {this.state.error}
                              </div>
                            </div>
                          )}
                          <span className="form__form-group-label">Phone No.</span>
                          <div className="form__form-group-field">
                            <div className="form__form-group-icon">
                              <CardIcon />
                            </div>
                            <Form.Control
                              autoFocus
                              type="number"
                              required
                              name="msisdn"
                              placeholder="Phone"
                              className="input-without-border-radius"
                              value={this.state.msisdn}
                              onChange={this.handleChangePhone}
                            />
                          </div>
                          <br />
                        </div>

                        <div className="account__btns">
                          <Button className="account__btn" type='submit' color="primary"> {
                            this.state.isLoading ? "Please wait..." : "Submit"
                          }</Button>
                        </div>

                      </Form>
                    </>
                  ) : null}
                  {otpConfirmation ? (
                    <>
                      <Form className="form login-form" onSubmit={this.OTPConfirmation}>
                        <h5><b>OTP Confirmation</b></h5>
                        <div className="form__form-group">
                          <br></br>
                          {this.state.isShowError ? (
                            <Alert color="success" className="alert--colored" >
                              <span>
                                {this.state.statusMessage}
                              </span>
                            </Alert>
                          ) : null}
                          {errorShow && (
                            <div>
                              <div
                                color="red"
                                style={{ fontSize: "13px", color: "red" }}>
                                {this.state.error}
                              </div>
                            </div>
                          )}
                          <span className="form__form-group-label">Confirmation Code.</span>
                          <div className="form__form-group-field">
                            <div className="form__form-group-icon">
                              <CardIcon />
                            </div>
                            <Form.Control
                              autoFocus
                              type="number"
                              required
                              name="optnumber"
                              maxLength="6"
                              placeholder="OTP"
                              className="input-without-border-radius"
                              value={this.state.optnumber}
                              onChange={this.handleChangeOTP}
                            />
                          </div>
                          <br />
                        </div>

                        <div className="account__btns">
                          <Button className="account__btn" type='submit' color="primary"> {
                            this.state.isLoading ? "Please wait..." : "Submit"
                          }</Button>
                        </div>
                        {/* <div className="account__have-account">
                        <p>Back to Login? <a href="#" onClick={this.changetologin}>Login</a></p>
                      </div> */}
                      </Form>
                    </>
                  ) : null}
                </Modal>
              </div>
            </div>
          </div>
        </div>
      </div>    
    );
  }
}

export default connect(state => ({ theme: state.theme }))(Landing);
